import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";

const TITLE = "Proces — Van URL naar live in dagen | IT Solutions";
const DESC =
  "Ons werkproces in 4 stappen: AI-analyse, live demo in 15 minuten, vaste prijs en go-live binnen 2–4 weken. Wij automatiseren wat anderen handmatig doen.";

import { ProcesPage } from "@/pages/proces";

export const Route = createFileRoute("/proces")({
  head: () => pageHead({ lang: "nl", pathWithoutLang: "/proces", title: TITLE, description: DESC }),
  component: ProcesPage,
});
